exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-80f452f8] .el-form-item__label{text-align:right}[data-v-80f452f8] .el-card__body{height:100%}.people-list[data-v-80f452f8]{height:calc(100% - 116px)}.tree-box[data-v-80f452f8]{height:calc(100% - 46px)}", ""]);

// exports
